export const MONTHLY_PREMIUM_ID = "ff41b330-c68b-4c1c-8153-8091e0dfd72e";

export const QUERY_KEYS = [
  "Firstname",
  "Middlename",
  "surname",
  "age",
  "agency",
  "assignedArea",
  "employmentType",
  "isGraduated",
  "isSubmitted",
  "oldRate",
  "oldSalaryGrade",
  "payCode",
  "payrollClassification",
  "position",
  "position.position_title",
  "salaryCode",
  "salaryGrade",
  "salaryPointer",
  "selectedSchedule",
  "seperationType",
  "suspension",
  "twentyFourSeven",
];

export const FILTER_KEYS = [
  "payrollType",
  "employmentType",
  "payItem",
  "seperationType",
  "suspension",
];